import { DomainEventNames } from "@unu/ui-enums";
import type {
  ApplyCareCardEventValues,
  ConditionsWeTreatEventValues,
  InsightsAdapter,
  PaymentEventValues,
  SelectCareCardTypeEventValues,
  SelectConsultTypeEventValues,
  SelectPathologyTypeEventValues,
  TagFunction,
} from "./types";

export function createInsightsAdapter(tag: TagFunction): InsightsAdapter {
  return {
    trackPayment: (values: PaymentEventValues) => {
      tag({
        name: DomainEventNames.Payment,
        parameters: values,
      });
    },

    trackSelectConsultType: (values: SelectConsultTypeEventValues) => {
      tag({
        name: DomainEventNames.SelectConsultType,
        parameters: values,
      });
    },

    trackConditionsWeTreat: (values: ConditionsWeTreatEventValues) => {
      tag({
        name: DomainEventNames.ConditionsWeTreat,
        parameters: values,
      });
    },

    trackSelectPathologyType: (values: SelectPathologyTypeEventValues) => {
      tag({
        name: DomainEventNames.SelectPathologyType,
        parameters: values,
      });
    },

    trackSelectCareCardType: (values: SelectCareCardTypeEventValues) => {
      tag({
        name: DomainEventNames.SelectCareCardType,
        parameters: values,
      });
    },

    trackApplyCareCard: (values: ApplyCareCardEventValues) => {
      tag({
        name: DomainEventNames.ApplyCareCard,
        parameters: values,
      });
    },
  };
}
